import { combineReducers } from "redux";
import isResultReducer from "./isResultReducer";
import menuRoleReducer from "./menuRoleReducer";
import userMenuReducer from "./userMenuReducer";
//IndexImportHygen
const allUserMenuReducer = combineReducers({
    isResultReducer,
    menuRoleReducer,
    userMenuReducer,
    //IndexUsingHygen
})
export default allUserMenuReducer;